import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/Login-img.png'
import {
    login as loginFacebook,
    logout as logoutFacebook
} from "webtonative/SocialLogin/facebook";
import {
    login as loginGoogle,
    logout as logoutGoogle
} from "webtonative/SocialLogin/google";
import {
    login as loginApple
} from "webtonative/SocialLogin/apple";
import axios from 'axios';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import logofr from '../Img/g-logo.png'
// import { auth } from "./Firebase/firebase.config";
// import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const Register = () => {
    const [step, setStep] = useState(1); // Track current step
    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [userType, setUserType] = useState("");
    const [showResendButton, setShowResendButton] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);
    const [otpworld1, setOtpworld1] = useState(false);
    const [otpworld2, setOtpworld2] = useState(false);
    const [confirmObj, setConfirmObj] = useState("");
    const navigate = useNavigate()
    const [emailLoad, setEmailload] = useState(true);
    const [verifyLoad, setVerifyload] = useState(true);
    const [load, setLoad] = useState(true)
    const [isNativeApp, setIsNativeApp] = useState(false);
    const url = process.env.REACT_APP_API_URL
    // const [formData, setFormData] = useState({
    //     userType: '',
    //     phone: '',
    //     otp: Array(6).fill(''),
    //     name: '',
    //     email: '',
    //     password: '',
    // });

    console.log("Perfume ID is:", process.env);

    const main_id = process.env.REACT_APP_PERFUME_ID

    // console.log(main_id)

    const otpRefs = useRef([]);

    // Handle phone number input
    const handlePhoneChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,10}$/.test(value)) { // Allow only numbers up to 10 digits
            setPhone(value);
        }
    };


    // Handle OTP input
    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 1) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < otp.length - 1) {
                otpRefs.current[index + 1].focus();
            }
        }
    };

    // Handle sending OTP
    const handleSendOtp = (e) => {
        e.preventDefault();
        // if (phone.length !== 10) {
        //     toast.error('Phone number must be exactly 10 digits.');
        //     return;
        // }
        sendOtp();

        // setStep(2);
    };


    // Handle verifying OTP
    const handleVerifyOtp = async () => {
        setVerifyload(false);
        const otpString = otp.join('');
        if (otpString === "" || otpString === null) {
            console.log('Please Enter a valid OTP');
        }


        try {
            const response = await fetch(`${url}/registeruser/api/verify-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, otp: otpString,main_id:main_id })

            })
            const res = await response.json();
            if (response.ok) {
                console.log(res);
                setVerifyload(true);
                setStep(3);
            }

        } catch (error) {
            setVerifyload(true);
            console.log(error);

        }
    };




    let sendOtp = async () => {
        setEmailload(false);
        try {
            

            const response = await fetch(`${url}/registeruser/api/send-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    main_id: main_id
                })
            })

            const res = await response.json()
            if (res.success) {
                console.log(res);
                setEmailload(true)
                toast.success('OTP sent successfully!');
                setStep(2);
            }else{
                 setEmailload(true)
                 toast.error(res.message);
            }
            localStorage.setItem("phone", email);


            if ("OTPCredential" in window) {
                navigator.credentials
                    .get({ otp: { transport: ["sms"] } })
                    .then((otp) => {
                        console.log(otp.code);
                        // setOpt(otp.code);
                        setEmailload(true)
                        // verifyOtp();
                    })
                    .catch((error) => {
                        setEmailload(true)
                        console.log("Error reading OTP:", error);
                    });
            }
            // setLoad(true) 
        } catch (error) {
            console.log(error);
            setEmailload(true)
            // setLoad(true)
        }
    }

    // Handle final registration
    const handleRegister = async (e) => {
        e.preventDefault();
        setLoad(false)
        try {
            if (!email.includes('@') || !email.includes('.')) {
                toast.error('Invalid email address.');
                setLoad(true);
                return;
            }
            if (password.length < 6) {
                toast.error('Password must be at least 6 characters long.');
                setLoad(true);
                return;
            }

            const response = await fetch(`${url}/registeruser/api/signup`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    mobile: phone,
                    full_name: name,
                    password: password,
                    main_id: main_id
                })
            })
            if (response.ok) {
                const res = await response.json();
                console.log(res);
                setLoad(true)
                toast.success('Registration successful!');
                navigate("/login");
                
            } else {
                setLoad(true)
            }
        } catch (error) {
            setLoad(true)
            console.log(error);
        }
    };

    const handleGoogleAuthSuccess = async (response) => {
        try {
            console.log("Google response credential:", response);
            if (!response.credential) {
                throw new Error("Google credential is missing.");
            }

            const res = await axios.post(`${url}/registeruser/api/google-signup`, {
                token: response.credential,
                main_id: process.env.REACT_APP_PERFUME_ID,
                // email: email,
            },
                {
                    withCredentials: true, // ✅ This allows cookies to be set
                },
            );
            console.log(res)
            if (res.status === 201) {
                console.log(res);

                navigate("/");

            } else if (res.status === 200) {

                navigate("/")

                // toast({
                //   description: res.data.message,
                //   status: "error",
                //   duration: 5000,
                //   isClosable: true,
                //   position: "top",
                // });
            }
        } catch (error) {
            console.error("Google Sign-Up Error:", error.message);
            toast({
                description: "An error occurred during sign-up. Please try again.",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top",
            });
        }
    };


    const handleLogingoggle = () => {
        if (isNativeApp) {
            // Trigger login via webtonative for native apps
            loginGoogle({
                callback: async (value) => {
                    try {
                        console.log("Google response credential:", value);


                        const res = await axios.post(`${url}/registeruser/api/google-signup`, {
                            token: value.idToken,
                            main_id: process.env.REACT_APP_PERFUME_ID,
                            // email: email,
                        }, {
                            withCredentials: true, // ✅ This allows cookies to be set
                        },
                        );

                        if (res.status === 201) {

                            navigate("/");

                        } else if (res.status === 200) {

                            navigate("/")

                            // toast({
                            //   description: res.data.message,
                            //   status: "error",
                            //   duration: 5000,
                            //   isClosable: true,
                            //   position: "top",
                            // });
                        }
                    } catch (error) {
                        console.error("Google Sign-Up Error:", error.message);
                        toast({
                            description: "An error occurred during sign-up. Please try again.",
                            status: "error",
                            duration: 5000,
                            isClosable: true,
                            position: "top",
                        });
                    }
                },
            });
        } else {
            // Handle Google Login for the website
            console.log("Redirecting to Google Login for website...");
        }
    };





    const handleGoogleAuthFailure = (error) => {
        console.error('Google authentication error:', error);
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div id="recaptcha-container" />
            <div className="login-bg">
                <div className="login-img">
                    <img src={loginImg} alt="" />
                </div>
                <div className="login-box">
                    {/* Render Step 1 */}
                    {step === 1 && (
                        <div>
                            <h2>Register</h2>
                            <GoogleOAuthProvider clientId="970745082348-o4pbibraknlf7rea9tonp32doti23k4g.apps.googleusercontent.com">
                                <form onSubmit={handleSendOtp}>
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />

                                    <p className="register">
                                        By continuing, I agree to the <Link to='/rules-and-regulations'>Terms of use</Link> & <Link to='/privacy-policy'>Privacy Policy</Link>
                                    </p>

                                    {
                                        emailLoad ? <button type="submit">Continue</button> :
                                            <button type="button" disabled={!emailLoad}>Loading...</button>
                                    }



                                </form>

                                <div className="auth-options">
                                    {isNativeApp ? (
                                        // Show a button for native app that triggers the logout modal
                                        <button
                                            onClick={handleLogingoggle}
                                            style={{
                                                background: "white", border: "1px solid lightgray", color: "white",
                                                borderRadius: "10px",
                                                fontWeight: "500",
                                                padding: "8px 24px",
                                                marginTop: "10px",
                                                boxShadow: "lg",
                                                cursor: "pointer"
                                            }}

                                            _hover={{ background: "#f1f1f1", transform: "scale(1.05)" }} // Hover effects

                                        >
                                            <img
                                                src={logofr}
                                                alt="Google Logo"
                                                boxSize="20px"
                                                mr={2}
                                            />
                                            Sign in with Google
                                        </button>

                                    ) : (
                                        <>
                                            {/* <button
                    onClick={handleLogingoggle}
                    style={{
                      background: "white", border: "1px solid lightgray", color: "white",
                      borderRadius: "10px",
                      fontWeight: "500",
                      padding: "8px 24px",
                      marginTop: "10px",
                      boxShadow: "lg",
                      cursor: "pointer"
                    }}

                    _hover={{ background: "#f1f1f1", transform: "scale(1.05)" }} // Hover effects
                  >
                    <img
                      src={logofr}
                      alt="Google Logo"
                      // boxSize="20px"
                      // mr={2}
                    />
                    Sign in with Google
                  </button> */}

                                            <GoogleLogin
                                                onSuccess={handleGoogleAuthSuccess}
                                                onError={handleGoogleAuthFailure}
                                            />
                                        </>
                                        // <Button
                                        //   onClick={handleLogingoggle}
                                        //   bg="white" // Background color
                                        //   color="black" // Text color
                                        //   fontWeight="500" // Bold text
                                        //   borderRadius="md" // Medium border radius
                                        //   border="1px solid lightgray" // Optional border
                                        //   padding="8px 24px" // Padding for size
                                        //   _hover={{ background: "#f1f1f1", transform: "scale(1.05)" }} // Hover effects
                                        //   boxShadow="lg" // Optional shadow for elevation
                                        //   mt={4}
                                        // >
                                        //   <Image
                                        //     src="https://developers.google.com/identity/images/g-logo.png"
                                        //     alt="Google Logo"
                                        //     boxSize="20px"
                                        //     mr={2}
                                        //   />
                                        //   Sign in with Google
                                        // </Button>

                                    )}
                                </div>
                            </GoogleOAuthProvider>
                            {/* <p className="register-divider">Or sign in with</p>
                            <div className="google">
                                Sign in with Google
                            </div> */}
                            <p className="register">
                                Already register? <Link to='/login'>Login now</Link>
                            </p>
                        </div>
                    )}

                    {/* Render Step 2 */}
                    {step === 2 && (
                        <div>
                            <h2>OTP Verification</h2>
                            <p>Enter the 6-digit verification code sent to your phone number</p>
                            <div className="otp-inputs">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleOtpChange(e, index)}
                                        className="otp-input"
                                        placeholder="-"
                                        ref={(el) => otpRefs.current[index] = el}
                                    />
                                ))}
                            </div>
                            {
                                verifyLoad ? <button onClick={handleVerifyOtp}>Verify OTP</button> :
                                    <button >Loading...</button>
                            }

                            <p className="register">
                                Already register <Link to='/login'>Login now</Link>
                            </p>
                        </div>
                    )}
                    {step === 3 && (
                        <div>
                            <h2>Register</h2>
                            <p>Hey, enter your details to get signed in<br />to your account</p>
                            <form onSubmit={handleRegister}>
                                <input
                                    type="text"
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    placeholder="Enter Phone Number"
                                />
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Full Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={email}
                                    readOnly
                                />
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                {
                                    load ? <button type="submit">Register</button> :
                                        <button type="button" disabled={!load}>Loading...</button>
                                }

                            </form>
                            {/* <p className="register-divider">Or sign in with</p>
                            <div className="google">
                                Sign in with Google
                            </div> */}
                            <p className="register">
                                Already register <Link to='/login'>Login now</Link>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Register;
